import { ErrorBoundary } from '@sentry/react'

const ErrorBoundaryLogin = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    Couldn't load login view. Something went wrong. Check Sentry
                    for logs
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default ErrorBoundaryLogin
